export default __webpack_public_path__ + "static/media/mark-attendance-enabled.444c0900.svg";